import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import type { MergedState } from 'src/app/shared/hooks/state';
import { useMergedStates } from 'src/app/shared/hooks/state';

import { prefetchSearchPageDataFromApi, useSearchPageDataFromApi } from './pageData';
import { prefetchSearchPageFcm, useAsyncSearchPageFcm } from './pageFcm';

export type SearchPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useSearchPageDataFromApi>[0];
}>;

export type SearchPageCombinedState = MergedState<
	ReturnType<typeof useSearchPageDataFromApi>,
	ReturnType<typeof useAsyncSearchPageFcm>
>;

export function usePageContext(prefetchedData?: SearchPagePrefetchedContext): SearchPageCombinedState {
	return useMergedStates(useSearchPageDataFromApi(prefetchedData?.pageData), useAsyncSearchPageFcm());
}

export async function prefetchPageContext(context: PrefetchContext): Promise<SearchPagePrefetchedContext> {
	const [pageData] = await Promise.all([prefetchSearchPageDataFromApi(context), prefetchSearchPageFcm(context)]);

	return { pageData };
}

export type SearchPagePrefetchedDataProps = PrefetchedDataProps<SearchPagePrefetchedContext>;
